"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgList = function SvgList(_ref) {
  var fill = _ref.fill,
      theme = _ref.theme,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "theme", "title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.333 5.333a1.333 1.333 0 100 2.667 1.333 1.333 0 000-2.667zm21.55 0H10.357c-.606 0-1.097.597-1.097 1.334C9.26 7.403 9.75 8 10.356 8h16.528c.605 0 1.096-.597 1.096-1.333 0-.737-.49-1.334-1.096-1.334zm-16.527 9.334h16.528c.605 0 1.096.597 1.096 1.333s-.49 1.333-1.096 1.333H10.356c-.606 0-1.097-.597-1.097-1.333s.491-1.333 1.097-1.333zm0 9.333h16.528c.605 0 1.096.597 1.096 1.333 0 .737-.49 1.334-1.096 1.334H10.356c-.606 0-1.097-.597-1.097-1.334 0-.736.491-1.333 1.097-1.333zM4 16a1.333 1.333 0 112.667 0A1.333 1.333 0 014 16zm1.333 8a1.333 1.333 0 100 2.667 1.333 1.333 0 000-2.667z",
      fill: fill || theme.colors.primary.main
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "list_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 4,
      y: 5,
      width: 24,
      height: 22,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.333 5.333a1.333 1.333 0 100 2.667 1.333 1.333 0 000-2.667zm21.55 0H10.357c-.606 0-1.097.597-1.097 1.334C9.26 7.403 9.75 8 10.356 8h16.528c.605 0 1.096-.597 1.096-1.333 0-.737-.49-1.334-1.096-1.334zm-16.527 9.334h16.528c.605 0 1.096.597 1.096 1.333s-.49 1.333-1.096 1.333H10.356c-.606 0-1.097-.597-1.097-1.333s.491-1.333 1.097-1.333zm0 9.333h16.528c.605 0 1.096.597 1.096 1.333 0 .737-.49 1.334-1.096 1.334H10.356c-.606 0-1.097-.597-1.097-1.334 0-.736.491-1.333 1.097-1.333zM4 16a1.333 1.333 0 112.667 0A1.333 1.333 0 014 16zm1.333 8a1.333 1.333 0 100 2.667 1.333 1.333 0 000-2.667z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#list_svg__a)",
      children: (0, _jsxRuntime.jsx)("path", {
        fill: fill || theme.colors.primary.main,
        d: "M-82.667-84h199.662v200H-82.667z"
      })
    })]
  }));
};

var _default = SvgList;
exports["default"] = _default;